<script>
  export let title, idx, show = false
</script>

<div class="accordion accordion-sm mb-3" id="accordion-{idx}">
  <details class="accordion-item" open={show}>
    <summary class="accordion-header" on:click|once>
      <span class="flex-grow-1">{title}</span>
      {#if $$slots.button}
        <span class="accordion-action me-3">
          <slot name="button" />
        </span>
      {/if}
      <svg class="accordion-icon" viewBox="0 0 16 16" aria-hidden="true">
        <path fill="none" stroke="currentColor" stroke-width="1.5" d="m3 6 5 5 5-5" />
      </svg>
    </summary>
    <div class="accordion-body bg-white">
      <slot />
    </div>
  </details>
</div>
